<panel width="400">
	<h1>{{ 'company.product-plan.undo-terminate' | translate }}</h1>

	<section>
		<date-input #terminationDateInput [label]="'company.product-plan.end-date' | translate" [(value)]="newEndDate" [minDate]="minDate" [required]="true" [filterDates]="subscriptionEndDatesFilter" />
	</section>
	<section>
		<button confirm (click)="undoTerminate()">{{ 'general.save' | translate }}</button>
	</section>
</panel>
